import ConfigPlayerModel from '../../../core/models/configplayerModel';

export default function parserPOCConfigPlayer(pocData) {
  const configPlayerModel = new ConfigPlayerModel();

  configPlayerModel.setPlayerAd(parseInt(pocData?.user?.player_ad || 0, 10) > 0);

  const isAov = parseInt(pocData?.user?.inview_activate || 0, 10) > 0;
  const isPre = parseInt(pocData?.user?.inview_prefold || 0, 10) > 0;
  const aovPre = isAov && isPre;
  configPlayerModel.setAOVPre(isAov && isPre);
  configPlayerModel.setAOVPos(isAov && !aovPre);
  configPlayerModel.setMeta(true);
  configPlayerModel.setFloatMargin(parseInt(pocData?.user?.inview_margin_top_bottom || 0, 10));
  configPlayerModel.setFloatPosition(parseInt(pocData?.user?.inview_position || 0, 10));
  configPlayerModel.setFloatWidthDesktop(parseInt(pocData?.user?.meta_width_desktop || 324, 10));
  configPlayerModel.setFloatWidthMobile(parseInt(pocData?.user?.meta_width_mobile || 150, 10));

  return configPlayerModel;
}
